import type { ClientAccessEntry } from '../../types';

/**
 * What to send as client_access on save. Clients keep all their entries;
 * dwa_standard users keep only the dwa-internal entry (its `dashboards` list is the
 * per-dashboard scoping set in this form; dropping it was why scoping never saved);
 * admins send null, which leaves the stored value untouched.
 */
export function clientAccessForSave(role: string, access: ClientAccessEntry[]): ClientAccessEntry[] | null {
  if (role === 'client') return access;
  if (role === 'dwa_standard') return access.filter((e) => e.client_id === 'dwa-internal');
  return null;
}
